export { ColorArea } from './ColorArea';
export { renderColorArea } from './renderColorArea';
export { useColorArea } from './useColorArea';
export type { ColorAreaProps, ColorAreaSlots, ColorAreaState } from './ColorArea.types';
